<template>
  <div class="directory">
    <div class="directory-list">
      <div class="guides-list-item">
        <div class="guides-list-item-head">
          <h3
            class="guides-list-item-title"
            v-bind:class="{ active: displayBody == 0 }"
            @click="openBody(0)"
          >
            Новые
          </h3>
          <h3
            class="guides-list-item-title"
            v-bind:class="{ active: displayBody == 1 }"
            @click="openBody(1)"
          >
            В работе
          </h3>
          <h3
            class="guides-list-item-title"
            v-if="userId == '1028' || userId == '1075'"
            v-bind:class="{ active: displayBody == 2 }"
            @click="openBody(2)"
          >
            На проверке
          </h3>
          <h3
            class="guides-list-item-title"
            v-if="userId == '1028' || userId == '1075'"
            v-bind:class="{ active: displayBody == 3 }"
            @click="openBody(3)"
          >
            Обработаны
          </h3>
        </div>
        <div class="directory-references-list">
          <reference-item
            v-for="item of referencesItems.filter(
              (it) => it.status == displayBody
            )"
            :key="item.id"
            :reference-item="item"
            :active-edit-item-id="activeEditItemId"
            :status="displayBody"
            @onEditItem="editItemHandler"
            @onTakeToWork="takeToWork"
            @onSendToReview="sendToReview"
            @onTakeToAccept="takeToAccept"
            @onSubmitToRevision="submitToRevision"
            @onDeleteItem="deleteItemHandler"
            @onCancelEditItem="cancelEditItemHandler"
          />
        </div>
      </div>
    </div>

    <el-dialog title="Создание записи" :visible.sync="createDialogVisible">
      <div class="guides-modal">
        <div class="guides-modal-row">
          <label>
            <span>Название</span>
            <el-input v-model="newReferenceName" autocomplete="off"></el-input>
          </label>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button>Отмена</el-button>
        <el-button type="primary" @click="saveReferencesItem()"
          >Сохранить</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// components
import ReferenceItem from "./ReferenceItem.vue";

// api
import {
  getRequestToCreateListApi,
  closeRequestToCreateApi,
  linkRequestToCreateApi,
  updateRequestToCreateApi,
  getRequestToCreateKeywordsApi,
  completeRequestToCreateApi,
  getRequestToCreateApi,
} from "../../../../api/manager";
import {
  getReferenceAddItemApi,
  getReferenceAddItemKeywordApi,
  getReferenceAddItemUsersApi,
} from "../../../../api/references";
// vuex
import { mapGetters } from "vuex";

import { GET_USERS } from "../../../../store/actions/users";

import { NEW_REQUESTS_COUNT } from "../../../../store/actions/manager";

export default {
  name: "Events",
  data() {
    return {
      group: "",
      referencesList: [],
      referencesItems: [],
      currentReferenceId: null,
      createDialogVisible: false,
      newReferenceName: "",
      newReferenceKeyword: "",
      newReferenceKeywordList: [],
      activeEditItemId: null,
      roles: this.$t("user.roles"),
      newUsers: "",
      displayBody: 0,
    };
  },
  computed: {
    ...mapGetters(["users", "isAdmin", "userId"]),
    fields() {
      if (!this.model) return [];

      return Object.keys(this.model).map((key) => {
        return {
          key,
          value: this.model[key] || "n/a",
        };
      });
    },
  },
  methods: {
    getRole(role) {
      return this.roles.find((item) => item.name === role).title;
    },
    loadReferences() {
      const params = {
        start: 0,
        limit: 50,
      };
      getRequestToCreateListApi(params).then((resp) => {
        this.referencesList = resp.data;
        this.referencesItems = resp.data.items.sort((a, b) => a.updated_date < b.updated_date ? 1 : -1);
      });
    },
    openBody(id) {
      this.cancelEditItemHandler();
      this.loadReferences();
      this.displayBody = id;
      
      //console.log("id", this.displayBody);
    },
    closeBody() {
      this.displayBody = 0;
    },
    addItemHandler(id) {
      this.currentReferenceId = id;
      this.createDialogVisible = true;
    },
    editItemHandler(id) {
      this.activeEditItemId = id;
      console.log("edit", this.activeEditItemId);
    },
    cancelEditItemHandler() {
      this.activeEditItemId = null;
      console.log("cancel", this.activeEditItemId);
    },
    takeToWork(id) {
      linkRequestToCreateApi({ id }).then(() => {
        this.$store.dispatch(NEW_REQUESTS_COUNT);
        this.loadReferences();
      });
    },
    sendToReview(id) {
      updateRequestToCreateApi({ id, status: 2 }).then(() => {
        this.loadReferences();
      });
    },
    takeToAccept(item) {
      const params = {
        reference_id: 4,
        keyword: item.title,
        group_id: item.group_id,
      };

      getReferenceAddItemApi(params).then((resp) => {
        let index = resp.data.id;
        getReferenceAddItemUsersApi({ user_id: item.user.id, item_id: index });
        getRequestToCreateKeywordsApi({ request_id: item.id }).then((resp) => {
          resp.data.map((it) => {
            const params = {
              reference_item_id: index,
              keyword: it.keyword,
              is_stop: it.is_stop,
              approximation: it.approximation,
              block: it.block,
            };

            getReferenceAddItemKeywordApi(params).then(() => {
              console.log("add key", item);
            });
          });
        });
        updateRequestToCreateApi({ id: item.id, status: 3 }).then(() => {
          this.loadReferences();
        });
      });
    },
    submitToRevision(id) {
      updateRequestToCreateApi({ id, status: 1 }).then(() => {
        this.loadReferences();
        this.$store.dispatch(NEW_REQUESTS_COUNT);
      });
    },
    openBody(id) {
      this.cancelEditItemHandler();
      this.loadReferences();
      this.displayBody = id;
    },
    deleteItemHandler(id) {
      closeRequestToCreateApi({ id: id }).then(() => {
        this.loadReferences();
      });
    },
    saveReferencesItem() {
      if (!this.currentReferenceId && this.newReferenceName === "") {
        return;
      }

      const params = {
        reference_id: this.currentReferenceId,
        keyword: this.newReferenceName,
        group_id: parseInt(this.group),
      };
      getReferenceAddItemApi(params).then(() => {
        this.currentReferenceId = null;
        this.newReferenceName = "";
        this.createDialogVisible = false;
        this.loadReferences();
      });
    },
  },

  mounted() {
    console.log("mounted");
    this.loadReferences();

    this.$store.dispatch(GET_USERS);
  },
  components: {
    ReferenceItem,
  },
};
</script>

<style>
.guides-head {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.directory-list {
  display: flex;
}
.guides-list-item:not(:last-child) {
  margin-bottom: 40px;
}
.guides-list-item-head {
  display: flex;
  align-items: center;
  margin: 20px 0 15px;
}
.guides-list-item-head .el-button--small,
.el-button--small.is-round {
  padding: 4px 15px;
}
.guides-list-item-title {
  margin: 0 20px 0 0;
  padding: 10px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.guides-list-item-title.active {
  background: #409eff;
  color: white;
}
.directory-references-list {
  position: absolute;
  left: 100px;
  width: 80%;
}
.guides-references-list-item {
}
.guides-modal-row {
}
.guides-modal-row span {
  display: block;
  margin-bottom: 5px;
}
</style>